
import { create } from "zustand";
import { devtools } from "zustand/middleware";




const storeApi = (set) => ({
    
    activarProveedor: null,
    totalProveedores: 0,

    setActivarProveedor(valor) {
        set({ activarProveedor: valor });
    },

});



export const useProveedoresStore = create()(
    devtools(
        storeApi
    )
)


